import {Component, Input, Signal} from '@angular/core';
import {environment} from '../../../environments/environment';
import {UserProfileService} from '../../services/user-profile.service';

@Component({
  selector: 'app-process-link',
  templateUrl: './process-link.component.html',
  styleUrls: ['./process-link.component.scss']
})
export class ProcessLinkComponent {

  @Input()
  processId: string;

  environment = environment;

  @Input()
  type: 'wf' | 'cr' // workflow or content repo

  staff: Signal<boolean>;

  constructor(userProfileService: UserProfileService) {
    this.staff = userProfileService.staff
  }
}
